import React from "react";
import { useFetchAppData } from "./Api";

export const AppHydration: React.FC = () => {
	useFetchAppData();

	return null;
};
